module.exports = __webpack_public_path__ + "img/ZG81_03.16544e8d.jpg";